/* Ряд частых блоков в шапке библиотеки. Закрытый — одна строка подписи, чтобы
   не отжимать вниз поиск и сами карточки. */
.wrap {
  margin-bottom: var(--sp-4);
}

.summary {
  color: var(--text-2);
  font-size: var(--fs-sm);
  font-weight: 600;
  cursor: pointer;
  list-style-position: inside;
}

.summary:hover {
  color: var(--text);
}

.summary::marker {
  color: var(--text-3);
}

.hint {
  margin-top: var(--sp-2);
  color: var(--text-3);
  font-size: var(--fs-xs);
  line-height: 1.45;
}

.chips {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-2);
  margin-top: var(--sp-3);
}

.chip {
  display: inline-flex;
  align-items: center;
  gap: var(--sp-2);
  padding: var(--sp-2) var(--sp-3);
  background: var(--surface);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius);
  color: var(--text-2);
  font-size: var(--fs-xs);
  text-align: left;
  cursor: pointer;
}

.chip:hover {
  background: var(--surface-2);
  border-color: var(--border-strong);
  color: var(--text);
}

/* Ответ на нажатие: блок уже в библиотеке, но карточка могла уехать под
   свёрнутую группу — галочка на месте нажатия говорит, что оно сработало. */
.chip[data-added='true'] {
  border-color: var(--ok);
  color: var(--ok);
}

.check {
  flex: none;
}

.count {
  font-family: var(--font-mono);
  font-variant-numeric: tabular-nums;
  color: var(--text-3);
}
